// extracted by css-extract-rspack-plugin
export default {"body2":"Body2_body2__nNv2N","body2-semi-bold":"Body2_body2-semi-bold__6pltM"};